(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initProductForm();
    initProductGallery();
    initCartDrawerQuantities();
    initProductRecommendations();
  });

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = !nav.hasAttribute('hidden');
      if (isOpen) {
        nav.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        nav.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    var close = document.querySelector('[data-search-close]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      if (!panel.hidden) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
    if (close) {
      close.addEventListener('click', function () {
        panel.hidden = true;
      });
    }
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) {
        e.preventDefault();
        openCartDrawer();
      }
      if (e.target.closest('[data-cart-close]')) {
        e.preventDefault();
        closeCartDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        var currentDrawer = document.querySelector('[data-cart-drawer]');
        if (newDrawer && currentDrawer) {
          var wasOpen = currentDrawer.classList.contains('is-open');
          currentDrawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) currentDrawer.classList.add('is-open');
          initCartDrawerQuantities();
        }
        updateCartCount();
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) { badge.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  function initCartDrawerQuantities() {
    var items = document.querySelectorAll('[data-cart-line]');
    items.forEach(function (item) {
      var minus = item.querySelector('[data-qty-decrease]');
      var plus = item.querySelector('[data-qty-increase]');
      var remove = item.querySelector('[data-qty-remove]');
      var valueEl = item.querySelector('[data-qty-value]');
      var line = item.getAttribute('data-cart-line');

      if (minus) {
        minus.addEventListener('click', function () {
          var qty = Math.max(0, parseInt(valueEl.textContent, 10) - 1);
          changeCartLine(line, qty);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          var qty = parseInt(valueEl.textContent, 10) + 1;
          changeCartLine(line, qty);
        });
      }
      if (remove) {
        remove.addEventListener('click', function () {
          changeCartLine(line, 0);
        });
      }
    });
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { refreshCartDrawer(); })
      .catch(function () {});
  }

  function initProductForm() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var variantsData = form.querySelector('[data-product-variants]');
    var variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    var idInput = form.querySelector('[data-product-variant-id]');
    var optionGroups = form.querySelectorAll('.product-form__option');
    var selected = {};

    optionGroups.forEach(function (group) {
      var index = group.getAttribute('data-option-index');
      var selectedPill = group.querySelector('.product-form__pill.is-selected');
      selected[index] = selectedPill ? selectedPill.getAttribute('data-option-value') : null;

      group.querySelectorAll('[data-option-value]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.product-form__pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          selected[index] = pill.getAttribute('data-option-value');
          updateSelectedVariant();
        });
      });
    });

    function updateSelectedVariant() {
      var match = variants.find(function (variant) {
        return Object.keys(selected).every(function (i) {
          return variant.options[parseInt(i, 10)] === selected[i];
        });
      });
      if (!match) return;
      idInput.value = match.id;

      var priceEl = form.closest('.product-page__info').querySelector('[data-product-price]');
      if (priceEl) {
        priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
          ? '<span class="product-page__price-compare">' + formatMoney(match.compare_at_price) + '</span><span class="product-page__price-sale">' + formatMoney(match.price) + '</span>'
          : '<span>' + formatMoney(match.price) + '</span>';
      }

      var submitBtn = form.querySelector('[data-add-to-cart]');
      var submitText = form.querySelector('[data-add-to-cart-text]');
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        if (submitText) submitText.textContent = match.available ? 'Add to Bag' : 'Sold Out';
      }

      if (match.featured_image) {
        var mainImg = document.getElementById('ProductMainImage');
        if (mainImg) mainImg.src = match.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '$1');
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var submitText = form.querySelector('[data-add-to-cart-text]');
      var originalText = submitText ? submitText.textContent : '';
      if (submitBtn) submitBtn.disabled = true;
      if (submitText) submitText.textContent = 'Adding…';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (submitText) submitText.textContent = 'Added ✓';
          refreshCartDrawer();
          openCartDrawer();
          setTimeout(function () {
            if (submitBtn) submitBtn.disabled = false;
            if (submitText) submitText.textContent = originalText;
          }, 1500);
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
          if (submitText) submitText.textContent = originalText;
        });
    });

    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');
    var qtyInput = form.querySelector('#Quantity');
    if (qtyMinus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
    }
    if (qtyPlus && qtyInput) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------------- Product gallery ---------------- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-main-image]');
    var mainImg = document.getElementById('ProductMainImage');
    var thumbs = document.querySelectorAll('[data-thumb]');
    if (!gallery || !mainImg || !thumbs.length) return;

    var thumbList = Array.prototype.slice.call(thumbs);

    function currentIndex() {
      var active = thumbList.findIndex(function (t) { return t.classList.contains('is-active'); });
      return active === -1 ? 0 : active;
    }

    function activate(index) {
      var normalized = ((index % thumbList.length) + thumbList.length) % thumbList.length;
      thumbList.forEach(function (t) { t.classList.remove('is-active'); });
      var thumb = thumbList[normalized];
      thumb.classList.add('is-active');
      mainImg.src = thumb.getAttribute('data-full');
      var thumbImg = thumb.querySelector('img');
      if (thumbImg) mainImg.alt = thumbImg.getAttribute('alt') || '';
    }

    thumbList.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { activate(index); });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { activate(currentIndex() - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { activate(currentIndex() + 1); });
    }

    var touchStartX = 0;
    var touchStartY = 0;
    var isTouching = false;

    gallery.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isTouching = true;
    }, { passive: true });

    gallery.addEventListener('touchend', function (e) {
      if (!isTouching) return;
      isTouching = false;
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      var deltaX = touch.clientX - touchStartX;
      var deltaY = touch.clientY - touchStartY;
      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) {
          activate(currentIndex() + 1);
        } else {
          activate(currentIndex() - 1);
        }
      }
    }, { passive: true });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') activate(currentIndex() - 1);
      if (e.key === 'ArrowRight') activate(currentIndex() + 1);
    });
  }

  function initProductRecommendations() {
    var container = document.querySelector('.product-recommendations');
    var url = window.__productRecommendationsUrl;
    var productId = window.__productId;
    if (!container || !url || !productId) return;

    fetch(url + '?section_id=main-product&product_id=' + productId + '&limit=4')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.querySelector('.product-recommendations');
        if (newSection && newSection.innerHTML.trim()) {
          container.innerHTML = newSection.innerHTML;
        }
      })
      .catch(function () {});
  }
})();
